import { pattern, string } from "superstruct";

export const legalIdSchema = pattern(string(), /^[0-9]{9,14}$/); // SIREN
